
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/team-dashboard",
      function () {
        return require("private-next-pages/guide/team-dashboard.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide/team-dashboard"])
      });
    }
  